module.exports = __webpack_public_path__ + "static/boys_fat-757c9f21bcb494d723287d629862e73f.jpg";